/* 
 * @author Adrian Nitu <adrian.nitu at gmail.com>
 * @version 0.1 - 2017-07-04
 */
;
(function ($, window, document, undefined) {
	var pluginName = 'keepAwake',
        defaults = {
			interval: 5*60*1000, //check for user presence (ms)
			refresh: 100*60*1000, //idle interval to refresh tokens (ms)
			events: "mousemove keydown mousedown touchstart scroll", //events for detecting user presence
			disabledSubmitTooltip: 'Please wait while CSRF token is being refreshed.',
			selectors: {
				form: "form",
				token: "input[name=_token]",
				meta: "meta[name=csrf-token]"
			},
			tokenRequest: {
				url: "/refresh-csrf",
				type: 'get',
				cache: false,
//				dataType: 'json'
			}
        };
	
    function Plugin( element, options ) {
		var self = this;
        this.element = element;
        this.options = $.extend(true, {}, defaults, options);
        
        this._defaults = defaults;
        this._name = pluginName;
        
		this.timeout = null;
		this.lastActive = new Date();
		this.csrfToken = $('meta[name=csrf-token]').attr('content');
		this.inactivePeriod = 0;
		
		var init = this.init = function () {
			onActive();
			$(document).on("visibilitychange webkitvisibilitychange mozvisibilitychange msvisibilitychange", onVisibilityChange);
		};
		
		var onVisibilityChange = function() {
			if (!(document.hidden || document.webkitHidden || document.mozHidden || document.msHidden)) {
				onActive();
			}
		};
		
		var onInterval = function(){
			$(document).once(self.options.events, onActive);
		};
		
		var onActive = function(e){
			self.inactivePeriod = - self.lastActive.getTime() + (self.lastActive = new Date()).getTime();
			if(self.inactivePeriod >= self.options.refresh) {
				refreshTokens();
			}
			self.timeout = setTimeout(onInterval, self.options.interval);
//			console.log("inactive for", self.inactivePeriod);
		};
		
		var refreshTokens = function(){
			toggleForms();
			$.ajax($.extend({
				success: function(data) {
					$(self.options.selectors.meta).attr('content', data);
					$(self.options.selectors.token).val(data);
					toggleForms(true);
//					console.log('new token',data);
				},
				error: function(xhr){
					//not much else left to do, just refresh the page and cross your fingers :)
//					console.log("error:", xhr);
					window.location.reload();
				}
			}, self.options.tokenRequest));
		};
		
		var toggleForms = function(release){
			//block forms submit until token is refreshed
			$submit = $(self.options.selectors.form + " *[type=submit]", document);
			if(release) {
				$submit.removeAttr('disabled');
				$submit.each(function(){
					$(this).attr('title', $(this).data('title'));
				});
			} else {
				$submit.attr('disabled', true);
				$submit.each(function(){
					$(this).data('title', $(this).attr('title'));
					$(this).attr('title', self.options.disabledSubmitTooltip);
				});
			}
		};
		
        this.init();
    };
	
/*    $.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName,
						new Plugin(this, options));
			}
		});
	};*/

	//singleton instance, source: stackoverflow.com/questions/20556277
	$[pluginName] = $.fn[pluginName] = function (options) {
		var args = arguments;

		if (options === undefined || typeof options === 'object') {
			if (!(this instanceof $)) {
				$.extend(defaults, options);
			}
			return this.each(function () {
				if (!$.data(this, 'plugin_' + pluginName)) {
					$.data(this, 'plugin_' + pluginName, new Plugin(this, options));
				}
			});
		} else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {
			var returns;

			this.each(function () {
				var instance = $.data(this, 'plugin_' + pluginName);
				if (!instance) {
					instance = $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
				}

				if (instance instanceof Plugin && typeof instance[options] === 'function') {
					returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
				}

				if (options === 'destroy') {
					$.data(this, 'plugin_' + pluginName, null);
				}
			});

			return returns !== undefined ? returns : this;
		}
	};
	
	//The handler is executed at most once per element for all event types.
	//source: https://stackoverflow.com/questions/24589084
	$.fn.once = function (events, callback) {
		var $this = $(this).on(events, myCallback);
		function myCallback(e) {
			$this.off(events, myCallback);
			callback.call(this, e);
		}
		return this;
	};
	
})(jQuery, window, document);